<template>
    <div class="popupVal">
        <van-field v-if="type == true" readonly clickable :value="bool" @click="showBool = true" style="width:15%" />
        <span v-else-if="type == false" style="float:left;width:15%;color:#fff">1</span>
        <van-popup v-model="showBool" position="bottom">
            <van-picker show-toolbar :columns="columnsBool" :default-index="0" @cancel="showBool = false" @confirm="onBool" />
        </van-popup>
        <van-field readonly clickable :value="value" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" :default-index="defaultIndex" @cancel="showPicker = false" @confirm="onConfirm" />
        </van-popup>
        <van-field v-model="input" :placeholder="'请输入' + value" class="van-fieldInp" />
    </div>
</template>
<script>
export default {
    props: ["data", "defaultIndex", "Value", "type"],
    data() {
        return {
            showPicker: false,
            value: this.Value, //选择类型
            columns: [], //
            input: "", //输入的值

            bool: "与",
            columnsBool: ["与", "或", "非"],
            showBool: false
        };
    },
    mounted() {
        for (var key in this.data) {
            //用javascript的for/in循环遍历对象的属性
            this.columns.push(key);
        }
    },
    methods: {
        onConfirm(value) {
            this.value = value;
            this.showPicker = false;
        },
        onBool(value) {
            this.bool = value;
            this.showBool = false;
        }
    }
};
</script>
<style lang="less">
.popupVal {
    overflow: hidden;
    margin-bottom: 0.5rem;
    .van-field {
        width: 67%;
        float: left;
        .van-cell__value {
            border-bottom: 1px solid #e3e3e3;
            padding: 0 0 0 0.5rem;
        }
    }
    .van-cell--clickable {
        width: 25%;
        background: url("../publics/image/07.png") right center no-repeat;
        background-size: 0.4rem;
        .van-cell__value {
            border: 0;
        }
    }
    input {
        height: 30px;
        font-size: 16px;
    }
}
</style>
